import React from "react"
import { Button, Divider } from "antd"
import logo from "../../../shared/assets/images/CQLogo.svg"
import { ReactComponent as AiChat } from "../../../shared/assets/images/AiChat.svg"
import { ReactComponent as AiUsers } from "../../../shared/assets/images/aiUsers.svg"
import { ReactComponent as AiInfo } from "../../../shared/assets/images/aiInfo.svg"
import { ReactComponent as AiQuestion } from "../../../shared/assets/images/aiQuestion.svg"
import { InterviewHeaderProps } from "./types"



const formatTime = (seconds: number) => {
    const mins = Math.floor(seconds / 60)
    const secs = seconds % 60
    return `${mins.toString().padStart(2, "0")}:${secs.toString().padStart(2, "0")}`
}

export const InterviewHeader: React.FC<InterviewHeaderProps> = ({
    elapsedTime,
    jobTitle,
    onToggleTranscript,
}) => {
    return (
        <header className="flex flex-wrap items-center justify-between px-6 py-3 bg-gray-800">
            <div className="flex items-center gap-4">
                <div className="flex items-center gap-2">
                    <div className="text-xl font-bold text-white">people</div>
                    <img src={logo || "/placeholder.svg"} alt="logo" width={32} height={32} />
                </div>
                <span className="text-sm text-gray-400">v2.x</span>
            </div>

            <div className="flex flex-wrap items-center gap-3">
                <div>
                    <span className="font-mono text-sm text-gray-300">{formatTime(elapsedTime)}</span>
                </div>
                <Divider type="vertical" className="h-4 border-gray-600" />
                <span className="text-sm font-medium text-gray-300">{jobTitle}</span>
                <Divider type="vertical" className="h-4 border-gray-600" />
                <Button type="text" className="hidden p-0 sm:inline-flex" onClick={onToggleTranscript}>
                    <AiChat />
                </Button>
                <Button type="text" className="p-0">
                    <AiUsers />
                </Button>
                <Button type="text" className="p-0">
                    <AiInfo />
                </Button>
                <Button type="text" className="p-0">
                    <AiQuestion />
                </Button>
            </div>
        </header>
    )
}

